"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityActivitySubject = exports.EntityActivitySubjectDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var sprintf_js_1 = require("sprintf-js");
var lodash_1 = require("lodash");
var entity_link_1 = require("./entity-link");
exports.EntityActivitySubjectDefaultProps = {
  possessionLabel: '',
  generic: false,
  external: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 1em;\n    font-weight: 600;\n    display: inline;\n  "], ["\n    font-size: 1em;\n    font-weight: 600;\n    display: inline;\n  "])))
});
var GlueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: 0 ", " 0 0;\n    white-space: nowrap;\n  "], ["\n    padding: 0 ", " 0 0;\n    white-space: nowrap;\n  "])), theme_1.theme.UNIT(1))
});
var ActionLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: inline;\n  "], ["\n    display: inline;\n  "])))
});
var PossessionLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: inline;\n  "], ["\n    display: inline;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  PersonLink: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  ActionLabel: styled_components_1.default.span(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ActionLabelStyles),
  PossessionLabel: styled_components_1.default.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), PossessionLabelStyles),
  Glue: styled_components_1.default.span(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), GlueStyles)
};
var EntityActivitySubject = function (props) {
  var className = props.className,
    entry = props.entry,
    definition = props.definition,
    t = props.t,
    children = props.children,
    generic = props.generic,
    possessionLabel = props.possessionLabel,
    external = props.external;
  var entity = entry.entity,
    person = entry.person,
    action = entry.action;
  var entityName = entity.openGraph && entity.openGraph.title || entity.name;
  var possessionSuffix = (0, lodash_1.endsWith)('s', entityName) ? '' : 's';
  var targetProps = external ? entity_link_1.linkTargetPropsFromOpenGraph : entity_link_1.linkTargetPropsFromSlug;
  var entityLabel = generic ? t(definition.aLabel) : possessionLabel ? (0, sprintf_js_1.sprintf)("%s'%s", entityName, possessionSuffix) : entityName;
  var verb = action === 'CREATE' ? 'added' : 'updated';
  var actionLabel = t(person ? " ".concat(verb, " ") : " was ".concat(verb));
  return react_1.default.createElement(My.Container, {
    className: className
  }, person ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(My.PersonLink, {
    entity: person
  }), react_1.default.createElement(My.ActionLabel, null, actionLabel), react_1.default.createElement(My.Link, {
    targetProps: targetProps,
    entity: entity
  }, entityLabel), ' ', possessionLabel && react_1.default.createElement(My.PossessionLabel, null, possessionLabel)) : react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(My.Link, {
    targetProps: targetProps,
    entity: entity
  }, entityLabel), possessionLabel && react_1.default.createElement(My.PossessionLabel, null, possessionLabel), react_1.default.createElement(My.ActionLabel, null, actionLabel)));
};
exports.EntityActivitySubject = EntityActivitySubject;
// export const entityActivitySubjectWithPossession = (label: string) => (props: EntityPlatformActivityComponentProps) => <EntityActivitySubject {...props} possessionLabel={label} />;
// export const entityActivityWithGeneric = () => (props: EntityPlatformActivityComponentProps) => <EntityActivitySubject {...props} generic />;
// export const entityActivityWithGenericExternal = () => (props: EntityPlatformActivityComponentProps) => <EntityActivitySubject {...props} external generic />;
exports.EntityActivitySubject.defaultProps = exports.EntityActivitySubjectDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;